import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  tenantId: string;
  permissions: string[];
}

interface AuthState {
  user: User | null;
  token: string | null;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
  hasPermission: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      setAuth: (user, token) => {
        localStorage.setItem('token', token);
        // Garantir que permissions seja sempre um array
        const normalizedUser = {
          ...user,
          permissions: Array.isArray(user.permissions) ? user.permissions : [],
        };
        set({ user: normalizedUser, token });
      },
      logout: () => {
        // Remover token do localStorage
        localStorage.removeItem('token');
        // Remover auth-storage do Zustand persist
        localStorage.removeItem('auth-storage');
        // Remover user se existir
        localStorage.removeItem('user');
        // Limpar estado do Zustand
        set({ user: null, token: null });
      },
      hasPermission: (permission: string) => {
        const { user } = get();
        if (!user) return false;

        // Garantir que permissions seja sempre um array
        const permissions = Array.isArray(user.permissions) ? user.permissions : [];
        
        // Admin do sistema e admin do tenant têm acesso a tudo
        if (
          permissions.includes('admin.system') ||
          permissions.includes('admin.tenant')
        ) {
          return true;
        }

        return permissions.includes(permission);
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
